import React from 'react';
import styled from 'styled-components';
import Card from '../Card';

const WarningMessageSmallScreenContainer = styled.div`
  margin-left: auto;
  margin-right: auto;

  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  text-align: center;
  color: ${(props) => props.theme.colors.dark};

  .iconAlert {
    width: 50px;
    min-width: 50px;
    min-height: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors['terra-cotta']};
    color: white;
    font-size: 40px;
    justify-content: center;
    align-items: center;
    display: flex;
    margin-top: 20px;
  }

  > * {
    width: 60vw;
    height: 25vh;
    min-height: 220px;
    margin-top: 25px;
    margin-bottom: 25px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  p {
    margin-top: 20px;
    width: 80%;
    line-height: 1.5;
    opacity: 0.9;
  }
`;

const WarningMessageSmallScreen = () => (
  <WarningMessageSmallScreenContainer>
    <Card>
      <div className="iconAlert">!</div>
      <p>
        {
          "Pour plus de détail, veuillez vous rendre sur l'application à partir d'un ordinateur ou d'une tablette"
        }
      </p>
    </Card>
  </WarningMessageSmallScreenContainer>
);

export default WarningMessageSmallScreen;
